var map = {
	"./alpabern.png": 464,
	"./bruderertrans.png": 465,
	"./daetwiler.png": 466,
	"./datarec.png": 467,
	"./deutschepost.png": 468,
	"./die-entsorger.png": 469,
	"./drisa.png": 470,
	"./eggenberger.png": 471,
	"./entsorgungsfachmarkt.png": 472,
	"./erz.png": 473,
	"./haeusle.png": 474,
	"./huegler.png": 475,
	"./hugelshofer.png": 476,
	"./immark.png": 477,
	"./innoplastics.png": 478,
	"./innorecycling.png": 479,
	"./kaufmann.png": 480,
	"./keller.png": 481,
	"./kva.png": 482,
	"./landolt.png": 483,
	"./lapp.png": 484,
	"./loacker.png": 485,
	"./model.png": 486,
	"./mueller.png": 487,
	"./mz.png": 488,
	"./nes.png": 489,
	"./norline.png": 490,
	"./papirec.png": 491,
	"./peterschmid.png": 492,
	"./solenthaler.png": 493,
	"./spross.png": 494,
	"./swissglas.png": 495,
	"./swissrepair.png": 496,
	"./swissterminal.png": 497,
	"./thuer.png": 498,
	"./toshiba.png": 499
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos ^\.\/.*$
// module id = 463
// module chunks = 1